import React from "react";
import Layout from "../../components/Layout";
import addToMailchimp from "gatsby-plugin-mailchimp";

export default class SubscribeForm extends React.Component {
  state = {
    email: "",
    responseMessage: "",
  };
  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    if (formData.get("phone") !== "") {
      console.log("Form submission is spam!!!");
      return;
    }
    const result = await addToMailchimp(this.state.email);
    this.setState({ message: result.msg });
  };

  render() {
    return (
      <Layout>
        <section className="section-newsletter">
          <div
            className="full-width-image-container margin-top-0"
            style={{
              backgroundImage: `url('/img/omt-blog-background.png')`,
            }}
          >
            <h1
              className="has-text-weight-bold is-size-1"
              style={{
                boxShadow: "0.5rem 0 0 var(--accent-color), -0.5rem 0 0 var(--accent-color)",
                backgroundColor: "var(--accent-color)",
                color: "white",
                padding: "1rem",
              }}
            >
              Subscribe To Our Newsletter
            </h1>
          </div>
        </section>
        <section className="section section-newsletter-content">
          <div className="container">
            <div className="content" style={{ textAlign: "center" }}>
              <div>
                <div>
                  <h1>OptimizeMyTravel Newsletter</h1>
                  <p>
                    <span>Receive updates and insights, right in your mailbox.</span>
                    <br></br>
                    <span>No spam ever. Unsubscribe anytime.</span>
                  </p>
                </div>
                <form
                  name="subscribeForm"
                  method="POST"
                  id="subscribe-form"
                  className="subscribe-form"
                  onSubmit={this.handleSubmit}
                >
                  {this.state.message && (
                    <div
                      className="message"
                      dangerouslySetInnerHTML={{ __html: this.state.message }}
                    />
                  )}
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Your email address*"
                    required
                    value={this.state.email}
                    onChange={this.handleInputChange}
                  />
                  <div aria-hidden="true" style={{ position: 'absolute', left: '-5000px' }}>
                    <input type="text" name="b_3345d06a0097afa02349776c2_e571c8638d" tabindex="-1" value=""/>
                  </div>
                  <input type="hidden" name="phone" value=""></input>
                  <button type="submit">
                    Subscribe
                  </button>
                  <span className="check-mailbox" style={{ color: "gray", fontSize: "0.9rem" }}>
                    *Check your "Inbox" or "Spam" folder for a confirmation email.
                  </span>                                    
                </form>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}
